// extracted by mini-css-extract-plugin
export var active = "ProductOptions-module--active--eae2f";
export var label = "ProductOptions-module--label--f36ff";
export var optionContainer = "ProductOptions-module--optionContainer--12e06";
export var optionList = "ProductOptions-module--optionList--13cd8";
export var outOfStock = "ProductOptions-module--outOfStock--8711e";
export var productOptions = "ProductOptions-module--productOptions--db8ed";
export var rectangleOption = "ProductOptions-module--rectangleOption--5efed";
export var rectangleSelection = "ProductOptions-module--rectangleSelection--df6f6";
export var swatchSelection = "ProductOptions-module--swatchSelection--77cea";